import { pushTrackingEvent } from './tracking';

// "Book a Demo" buttons: if the current page already has the demo form, scroll to it
// and focus the first field. Otherwise let the link open /demo, where the form is first.
export const goToDemoForm = (event, source = 'button', delay = 0) => {
  if (typeof document === 'undefined') return;
  pushTrackingEvent('demo_cta_click', { page_path: window.location.pathname, cta_source: source });
  const section = document.getElementById('demo');
  if (!section) return;
  if (event) event.preventDefault();
  setTimeout(() => {
    const top = section.getBoundingClientRect().top + window.pageYOffset - 72;
    window.scrollTo({ top, behavior: 'smooth' });
    // Focus the first field on desktop only; on phones it would pop the keyboard over the form.
    if (window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
      setTimeout(() => {
        const field = section.querySelector('input:not([type="hidden"]), select, textarea');
        if (field) field.focus({ preventScroll: true });
      }, 700);
    }
  }, delay);
};
